export enum ThumbnailSize {
  XS = 'xs',    // 50px
  S = 's',      // 100px
  M = 'm',      // 400px
}
